import { Typography } from "@mui/material";
import { ContentTypography } from "../ServiceModal.styles";

export function UserInvalid() {
    const modalTitle = <Typography>Konto gesperrt!</Typography>;
    const modalContent = (
        <ContentTypography>
            Aufgrund eines Verstoßes gegen unsere Richtlinien ist die Erstellung
            von Beiträgen und Nachrichten nicht mehr möglich.
        </ContentTypography>
    );
    return { modalTitle, modalContent, autoClosingModal: true };
}
